module.exports = __webpack_public_path__ + "img/boom-radio.9e910742.png";